const ChartIndicator = () =>
  <svg width="304" height="35" viewBox="0 0 304 35" fill="none">
    <path d="M1.5 33.5L27.3853 6.44003C30.4037 3.28465 34.5806 1.5 38.9472 1.5L303.5 1.5" stroke="#0d3073" strokeWidth="2" />
  </svg>

export default ChartIndicator;
